import styled, { withTheme, DefaultTheme } from 'styled-components';
import useI18n from '../../common/hooks/useI18n';
import { Modal } from 'antd';
import * as flatTypeUtils from '../../common/helpers/flatType.utils';
import { IFlat } from '../../common/model/flat.model';
import { useMediaQuery } from 'react-responsive';

type Props = {
  isVisible: boolean;
  onClose: () => void;
  flat: IFlat;
  theme: DefaultTheme;
};

const LinksContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const LinksContainer2 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
`;

const LinkText = styled.a`
  color: #898989;
`;

const Logo = styled.div<{ logoUrl: string }>`
  height: 22px;
  width: 22px;
  background-image: url(${(props) => props.logoUrl});
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: center center;
  margin-right: 4px;
`;

const ShareLink = ({
  logoUrl,
  href,
  children,
}: {
  logoUrl: string;
  href: string;
  children: any;
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '30px' }}>
      <Logo logoUrl={logoUrl} />
      <LinkText as="a" target="_blank" href={href}>
        {children}
      </LinkText>
    </div>
  );
};

const ShareModal = ({
  isVisible,
  onClose,
  flat,
  theme,
}: Props): JSX.Element => {
  const i18n = useI18n();
  const isSmDown = useMediaQuery({ query: theme.breakpoints.smd });

  const title = i18n.t('flatDetail.title', {
    type: i18n.t(flatTypeUtils.getFlatTypeLabel(flat.type)),
    city: flat.city,
    zone: flat.zone,
  });
  const description = i18n.t('flatDetail.description', {
    type: flat.type,
    zone: flat.zone,
    city: flat.city,
    sqrMeters: flat.sqrMeters,
    rooms: flat.rooms,
    bathrooms: flat.bathrooms,
    price: flat.price,
  });

  let url;
  if (process.browser) {
    url = window.location.href;
  } else {
    url = null;
  }

  return (
    <Modal
      title={i18n.t('flatDetail.share.modalTitle')}
      open={isVisible}
      onCancel={onClose}
      footer={null}
      centered={true}
      bodyStyle={{ height: 'inherit' }}
    >
      <LinksContainer>
        <LinksContainer2>
          {isSmDown ? (
            <ShareLink
              logoUrl="/images/whatsapp_logo.svg"
              href={`whatsapp://send?text=${url}`}
            >
              Whatsapp
            </ShareLink>
          ) : null}
          <ShareLink
            logoUrl="/images/facebook_logo.svg"
            href={`https://www.facebook.com/sharer.php?u=${url}`}
          >
            Facebook
          </ShareLink>
          <ShareLink
            logoUrl="/images/twitter_logo.svg"
            href={`https://twitter.com/intent/tweet?url=${url}&text=${title}&via=`}
          >
            Twitter
          </ShareLink>
          <ShareLink
            logoUrl="/images/email_logo.svg"
            href={`mailto:%7Bemail_address%7D?subject=${title}&body=${url}%20${description}`}
          >
            Email
          </ShareLink>
        </LinksContainer2>
      </LinksContainer>
    </Modal>
  );
};

export default withTheme(ShareModal);
